// src/api/auth/login.js
import axiosInstance from '@/lib/axios';




export async function redirectUser() {
    const token = localStorage.getItem('authToken');
    const tokenType = localStorage.getItem('tokenType');

    if (!token || !tokenType) {
        throw new Error('Unauthorized. Please log in.');
    }

    try {
        const { data: user } = await axiosInstance.get('/users/me', {
            headers: {
                Authorization: `${tokenType} ${token}`,
            },
        });

        return user;

    } catch (error) {
        const status = error.response?.status;

        if (status === 401) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('tokenType');
            throw new Error('Unauthorized. Authentication expired.');
        }

        throw new Error('Failed to fetch user data');
    }
}


